import React from 'react';
import { formatPrice } from 'utils/priceUtils';

interface Wholesale {
  wholesaleId?: string | null;
}

interface Deal {
  wholesaleId?: string | null;
  packagingPrice?: number | null;
}

interface WholesaleDealPriceCellsProps {
  wholesales: readonly (Wholesale | null | undefined)[] | null | undefined;
  deals: readonly (Deal | null | undefined)[] | null | undefined;
  /** 卸ごとのtd keyを指定する。省略時はwholesaleIdをそのまま使う。 */
  getKey?: (wholesaleId: string | null | undefined, index: number) => string;
}

/**
 * 卸ごとの取引価格セル(td rowSpan={3})を描画する。
 * QuotationDetail/DraftQuotationで重複していた同一ロジックを共通化した。
 */
export const WholesaleDealPriceCells: React.FC<WholesaleDealPriceCellsProps> = ({
  wholesales,
  deals,
  getKey,
}) => {
  return (
    <>
      {wholesales?.map((wholesale, index) => {
        const deal = deals?.find((d) => d?.wholesaleId === wholesale?.wholesaleId);
        const key = getKey ? getKey(wholesale?.wholesaleId, index) : wholesale?.wholesaleId;
        return (
          <td rowSpan={3} key={key} className="align-middle text-nowrap">
            {formatPrice(deal?.packagingPrice)}
          </td>
        );
      })}
    </>
  );
};
